const CooldownList = [
  {
    name: '5 минут',
    value: 60 * 5,
  },
  {
    name: '15 минут',
    value: 60 * 15,
  },
  {
    name: '30 минут',
    value: 60 * 30,
  },
  {
    name: '1 час',
    value: 60 * 60,
  },
  {
    name: '3 часа',
    value: 60 * 60 * 3,
  },
  {
    name: '6 часов',
    value: 60 * 60 * 6,
  },
  {
    name: '12 часов',
    value: 60 * 60 * 12,
  },
  {
    name: '24 часа',
    value: 60 * 60 * 24,
  },
]

export { CooldownList }
